import { render, staticRenderFns } from "./checkAccept.vue?vue&type=template&id=f236944c&scoped=true&"
import script from "./checkAccept.vue?vue&type=script&lang=js&"
export * from "./checkAccept.vue?vue&type=script&lang=js&"
import style0 from "./checkAccept.vue?vue&type=style&index=0&id=f236944c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f236944c",
  null
  
)

export default component.exports